import React, { useMemo, useEffect, useState, useRef } from "react";
import { Accordion } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { CAMPAIGNPRODUCTS, CAMPAIGNPRODUCTSFilterproduct } from "../../store/Compaign/Action";
import { useStateValue } from "../../store/state";
import campaignpage from "../../assets/images/campaign/Vector@3x.png"

const TOKEN = localStorage.getItem("token");
const COMPANYID = localStorage.getItem("companyid");
const USERID = localStorage.getItem("userid");

const STOREID = localStorage.getItem("storeid");
const CampaignSidebar = ({
  products,
  Id,
  currentPage,
  setCurrentPage,
  categoryId,
  currentSelection,
  setCurrentSelection,
  type,
}) => {
  const { t } = useTranslation();

  const [applyFilter, setApplyFilter] = useState(false);
  const [mobileCategory, setMobileCategory] = useState("");
  const [{ filteredProductscampaign }, dispatch] = useStateValue();

  useEffect(() => {
    if (Id) {
      CAMPAIGNPRODUCTSFilterproduct(
        dispatch,

        TOKEN,
        Id,
        STOREID,
        categoryId
      );
    }
  }, []);

  // Add ref to track last selected ID to prevent duplicate calls
  const lastSelectedId = useRef(null);

  // Clean up the last selected ID when component unmounts
  useEffect(() => {
    return () => {
      lastSelectedId.current = null;
    };
  }, []);

  // Single function to handle all category changes and API calls
  const handleCategorySelection = (selectedId) => {
    // Prevent any duplicate calls
    if (selectedId === lastSelectedId.current) {
      return;
    }

    lastSelectedId.current = selectedId;

    // Make only one API call with the selected ID
    CAMPAIGNPRODUCTS(
      dispatch,
      TOKEN,
      COMPANYID,
      STOREID,
      USERID,
      Id,
      STOREID,
      categoryId,
      selectedId,
      1,
      "BrandY",
      "CountryX",
      "BrandY",
      "coffeeshop",
      "household",
      "sme"
    );
  };

  // Add resetFilter function
  const resetFilter = () => {
    // Reset all states to initial values
    setCurrentSelection({ ID: "", subID: "" });
    setMobileCategory("");
    setCurrentPage(1);
    // Call API to reset to all products
    CAMPAIGNPRODUCTS(
      dispatch,
      TOKEN,
      COMPANYID,
      STOREID,
      USERID,
      Id,
      STOREID,
      categoryId,
      "", // Empty category ID to show all products
      1,
      "BrandY",
      "CountryX",
      "BrandY",
      "coffeeshop",
      "household",
      "sme"
    );
  };

  const LEFTFILTERMEMO = useMemo(() => {
    return (
      <Accordion>
        <div className="category-heading">{t("category")}</div>
        <button
          className={`all_category ${!currentSelection?.ID && !currentSelection?.subID ? "selectedFilter" : ""
            }`}
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            setCurrentSelection({ ID: "", subID: "" });
            setCurrentPage(1);
            CAMPAIGNPRODUCTS(
              dispatch,
              TOKEN,
              COMPANYID,
              STOREID,
              USERID,
              Id,
              STOREID,
              categoryId,
              "",
              1
            );
          }}
        >
          {t("All")}
        </button>
        {Array.isArray(filteredProductscampaign) && filteredProductscampaign.map((category, i) => (
          <Accordion.Item eventKey={i} key={category.id}>
            <Accordion.Header
              className={`${currentSelection?.ID === category.id && !currentSelection?.subID ? "selectedFilter" : ""
                }`}
              onClick={(e) => {
                setCurrentPage(1);
                dispatch({ type: 'SET_CATEGORY' });
                setCurrentSelection({ ID: category.id, subID: "" });
                // Call the API with the category id
                CAMPAIGNPRODUCTS(
                  dispatch,
                  TOKEN,
                  COMPANYID,
                  STOREID,
                  USERID,
                  Id,
                  STOREID,
                  categoryId,
                  category.id, // <-- Use the category id here
                  1,
                  "BrandY",
                  "CountryX",
                  "BrandY",
                  "coffeeshop",
                  "household",
                  "sme"
                );

                // Optionally, log for debugging
                console.log("Category header clicked, API called with category id:", category.id);
              }}
            >
              {t(category.name)}
            </Accordion.Header>
            {category.children_data && category.children_data.length > 0 && (
              <Accordion.Body>
                <ul>
                  {category.children_data.map(subcategory => (
                    <li
                      key={subcategory.id}
                      className={`${currentSelection?.subID === subcategory.id ? "selectedFilter" : ""
                        }`}
                      onMouseDown={(e) => {
                        // Prevent accordion toggle
                        e.stopPropagation();
                      }}
                      onClick={(e) => {
                        // Stop all event propagation
                        setCurrentPage(1);
                        e.preventDefault();
                        e.stopPropagation();
                        e.nativeEvent.stopImmediatePropagation();
                        // Update UI state
                        setCurrentSelection({
                          ID: category.id,
                          subID: subcategory.id
                        });
                        return false;
                      }}
                    >
                      {t(subcategory.name)}
                    </li>
                  ))}
                </ul>
              </Accordion.Body>
            )}
          </Accordion.Item>
        ))}
      </Accordion>
    );
  }, [filteredProductscampaign, currentSelection, t]);

  const MOBILELEFTFILTERMEMO = useMemo(() => {
    return (
      <>
        {window.innerWidth <= 912 ? (
          <div className="PRODUCTPLP__MOBILE__SIDEBAR">
            <span
              data-bs-toggle="offcanvas"
              data-bs-target="#offcanvasBottom"
              aria-controls="offcanvasBottom"
            >
              <img src={campaignpage} style={{ width: "20px", marginLeft: "12px" }} alt="" />
            </span>

            <div
              className="offcanvas offcanvas-bottom"
              tabIndex="-1"
              id="offcanvasBottom"
              aria-labelledby="offcanvasBottomLabel"
            >
              <div className="offcanvas-header">
                <h5 className="offcanvas-title" id="offcanvasBottomLabel">
                  Filter By {filteredProductscampaign?.name}
                </h5>
                <button
                  type="button"
                  className="btn-close text-reset"
                  data-bs-dismiss="offcanvas"
                  aria-label="Close"
                ></button>
              </div>
              <div className="offcanvas-body small">
                {mobileCategory?.children_data && mobileCategory.children_data.length > 0 ? (
                  <ul>
                    {mobileCategory.children_data.map(child => (
                      <li
                        key={child.id}
                        className={`${currentSelection?.subID === child.id && "selectedFilter"}`}
                        onClick={() => {
                          setCurrentSelection({
                            ID: mobileCategory.id,
                            subID: child.id,
                          });
                          handleCategorySelection(child.id);
                        }}
                      >
                        {t(child.name)}
                      </li>
                    ))}
                  </ul>
                ) : (
                  <div>No subcategories available</div>
                )}
                <div className="offcanvas__buttons">
                  <button onClick={resetFilter} className="offcanvas__reset">
                    Reset
                  </button>
                  <button
                    onClick={() => setApplyFilter(true)}
                    className="offcanvas__apply"
                    data-bs-dismiss="offcanvas"
                  >
                    Apply
                  </button>
                </div>
              </div>
            </div>
            <div className="PRODUCTPLP__MENU">
              <span
                className={`${mobileCategory === "" && "selectedMobileMenu"}`}
                onClick={() => {
                  setCurrentPage(1);
                  setMobileCategory("");
                  setCurrentSelection({ ID: "", subID: "" });

                  // Call the API to fetch all products again
                  let TOKEN = localStorage.getItem("token");
                  let COMPANYID = localStorage.getItem("companyid");
                  let USERID = localStorage.getItem("userid");
                  let STOREID = localStorage.getItem("storeid");
                  let COUNTRYDATA = "CountryX";
                  let BRANDDATA = "BrandY";

                  CAMPAIGNPRODUCTS(
                    dispatch,
                    TOKEN,
                    COMPANYID,
                    STOREID,
                    USERID,
                    Id,
                    STOREID,
                    categoryId,
                    "",
                    1,
                    BRANDDATA,
                    COUNTRYDATA,
                    "BrandY",
                    "coffeeshop",
                    "household",
                    "sme"
                  );
                }}
              >
                {t("All")}
              </span>
              {filteredProductscampaign?.map((el, i) => (
                <span
                  className={`${mobileCategory.id === el.id && "selectedMobileMenu"
                    }`}
                  onClick={() => {
                    setMobileCategory(el);
                    setCurrentSelection({ ID: el.id, subID: "" });
                    // API Call for selected category
                    let TOKEN = localStorage.getItem("token");
                    let COMPANYID = localStorage.getItem("companyid");
                    let USERID = localStorage.getItem("userid");
                    let STOREID = localStorage.getItem("storeid");
                    let COUNTRYDATA = "CountryX";
                    let BRANDDATA = "BrandY";
                    setCurrentPage(1);

                    CAMPAIGNPRODUCTS(
                      dispatch,
                      TOKEN,
                      COMPANYID,
                      STOREID,
                      USERID,
                      Id,
                      STOREID,
                      categoryId,
                      el.id, // Use the selected category ID
                      1,
                      BRANDDATA,
                      COUNTRYDATA,
                      "BrandY",
                      "coffeeshop",
                      "household",
                      "sme"
                    );
                  }}
                  key={i}
                >
                  {t(el?.name)}
                </span>
              ))}
            </div>
          </div>
        ) : null}
      </>
    );
  }, [filteredProductscampaign, currentSelection, mobileCategory, t]);

  return (
    <>
      {type === "web" ? (
        <div className="PRODUCTPLP__SIDEBAR">{LEFTFILTERMEMO}</div>
      ) : null}
      {type === "mobile" ? <div className="PRODUCTPLP__SIDEBAR">{MOBILELEFTFILTERMEMO}</div> : null}
    </>
  );
};

export default CampaignSidebar;
